if (!customElements.get('art-finishing-options')) {
  customElements.define('art-finishing-options', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.form = this.closest('form');
      if (!this.form) return;
      this.variants = JSON.parse(this.querySelector('[data-finish-variants]').textContent);
      this.mountType = this.querySelector('[data-mount-type]');
      this.onChange = () => this.update();
      this.validate = event => {
        if (!this.hidden && !this.form.checkValidity()) {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.form.reportValidity();
        }
      };
      this.form.addEventListener('change', this.onChange);
      this.form.addEventListener('submit', this.validate, true);
      this.update();
    }
    disconnectedCallback() {
      if (this.form) {
        this.form.removeEventListener('change', this.onChange);
        this.form.removeEventListener('submit', this.validate, true);
      }
      this.ready = false;
    }
    update() {
      const id = this.form.querySelector('[name="id"]')?.value;
      const variant = this.variants.find(item => String(item.id) === String(id));
      const title = (variant?.title || '').toLowerCase();
      const framed = title.includes('framed') && !title.includes('unframed');
      const mounted = title.includes('mounted') && !title.includes('unmounted');
      const active = framed || mounted;
      const doubleMount = this.mountType.value === 'Double mount';
      this.hidden = !active;
      this.querySelector('[data-frame-only]').hidden = !framed;
      this.querySelector('[data-frame-only]').disabled = !framed;
      this.querySelector('[data-mount-fields]').disabled = !active;
      this.querySelector('[data-border-fields]').hidden = !doubleMount;
      this.querySelectorAll('input, select, textarea').forEach(input => {
        const frameInput = !!input.closest('[data-frame-only]');
        const borderInput = input.hasAttribute('data-border-input');
        const enabled = active && (!frameInput || framed) && (!borderInput || doubleMount);
        input.disabled = !enabled;
        input.required = enabled && (input.hasAttribute('data-needed') || borderInput);
      });
      const fastCheckout = this.form.querySelector('.shopify-payment-button');
      if (fastCheckout) fastCheckout.hidden = active;
    }
  });
}
